<section class="platform-page">
  <header class="platform-page__header">
    <div>
      <p class="platform-page__eyebrow">Organizations</p>
      <h2>Manage Organizations</h2>
      <p>Create organizations, update details, rotate credentials, and enable or disable access.</p>
    </div>
    <button type="button" mat-flat-button color="primary" (click)="openCreateComposer()">
      <mat-icon aria-hidden="true">add_business</mat-icon>
      New Organization
    </button>
  </header>

  @if (generatedCredentials(); as credentials) {
    <mat-card class="credentials-card">
      <div class="credentials-card__header">
        <div>
          <h3>{{ credentials.organizationName }} Credentials</h3>
          <p>Copy these now. The secret is intended for secure server-side storage.</p>
        </div>
        <button type="button" mat-icon-button aria-label="Dismiss credentials" (click)="clearGeneratedCredentials()">
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </div>
      <div class="credentials-grid">
        <label>
          <span>Access key</span>
          <input type="text" [value]="credentials.appKey" readonly />
        </label>
        <label>
          <span>Access secret</span>
          <input type="text" [value]="credentials.appSecret" readonly />
        </label>
      </div>
    </mat-card>
  }

  <div class="organizations-layout">
    <mat-card class="organizations-card">
      <div class="organizations-toolbar">
        <mat-form-field appearance="outline">
          <mat-label>Search organizations</mat-label>
          <input matInput type="text" [value]="searchTerm()" (input)="updateSearchTerm($any($event.target).value)" />
          <mat-icon matSuffix aria-hidden="true">search</mat-icon>
        </mat-form-field>
      </div>

      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Organization</th>
              <th>SID</th>
              <th>Status</th>
              <th>Credentials</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (organization of filteredOrganizations(); track organization.id) {
              <tr>
                <td>
                  <div class="org-meta">
                    <strong>{{ organization.name }}</strong>
                    <p>{{ organization.email }} · {{ organization.phone }}</p>
                  </div>
                </td>
                <td>{{ organization.sid || '-' }}</td>
                <td>
                  <span class="status-chip" [class.status-chip--inactive]="!organization.is_active">
                    {{ organization.is_active ? 'Active' : 'Disabled' }}
                  </span>
                </td>
                <td>
                  <button type="button" class="table-link-button" (click)="requestCredentials(organization)">
                    Generate key & secret
                  </button>
                </td>
                <td class="table-actions">
                  <button type="button" mat-stroked-button color="primary" (click)="openEditComposer(organization)">Edit</button>
                  <button type="button" mat-stroked-button color="primary" (click)="confirmToggleActive(organization)">
                    {{ organization.is_active ? 'Disable' : 'Enable' }}
                  </button>
                </td>
              </tr>
            }
            @if (filteredOrganizations().length === 0) {
              <tr>
                <td colspan="5" class="table-empty">No organizations matched your search.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </mat-card>

    @if (isComposerOpen()) {
      <mat-card class="composer-card">
        <div class="composer-card__header">
          <div>
            <p class="platform-page__eyebrow">{{ editingOrganizationId() ? 'Edit' : 'Create' }}</p>
            <h3>{{ editingOrganizationId() ? 'Update Organization' : 'New Organization' }}</h3>
          </div>
          <button type="button" mat-icon-button aria-label="Close form" (click)="closeComposer()">
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        </div>

        <form class="composer-form" [formGroup]="organizationForm" (ngSubmit)="saveOrganization()">
          <app-validation-error [errors]="validationErrors()"></app-validation-error>

          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput type="text" formControlName="name" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Phone</mat-label>
            <input matInput type="text" formControlName="phone" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Address line 1</mat-label>
            <input matInput type="text" formControlName="address_line_1" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Address line 2</mat-label>
            <input matInput type="text" formControlName="address_line_2" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>City</mat-label>
            <input matInput type="text" formControlName="city" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>State</mat-label>
            <input matInput type="text" formControlName="state" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Country</mat-label>
            <input matInput type="text" formControlName="country" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>ZIP</mat-label>
            <input matInput type="text" formControlName="zip" />
          </mat-form-field>

          <mat-checkbox formControlName="is_active">Organization active</mat-checkbox>

          <div class="composer-actions">
            <button type="button" mat-stroked-button color="primary" (click)="closeComposer()">Cancel</button>
            <button type="submit" mat-flat-button color="primary">{{ editingOrganizationId() ? 'Save Changes' : 'Create Organization' }}</button>
          </div>
        </form>
      </mat-card>
    }
  </div>
</section>
